// Легаси тема на модула „Маркиране" — стойностите са ПРЕНАСОЧЕНИ към pos-*
// токените от src/index.css @theme (редизайнът 0.0.116), за да са в тон
// още нередизайнатите файлове (вторични модали, TopBar). НЕ добавяй нови
// употреби — новият код ползва Tailwind pos-* класове директно.
import { fontFamilies } from "../../../styles/typography";

export const R = {
  bg: "var(--color-pos-canvas)", // pos-canvas
  surface: "var(--color-pos-card)", // pos-card
  sidebarBg: "var(--color-pos-line2)", // pos-line2
  border: "var(--color-pos-line2)", // pos-line2
  borderMed: "var(--color-pos-ctl)", // pos-ctl
  text: "var(--color-pos-ink)", // pos-ink
  textSoft: "var(--color-pos-soft)", // pos-soft
  textMuted: "var(--color-pos-muted)", // pos-muted
  ink: "var(--color-pos-ink)", // pos-ink
  brand: "var(--color-pos-accent)", // pos-accent
  brandDeep: "var(--color-pos-accent-ink)", // pos-accent-ink
  brandTint: "var(--color-pos-selected-bg)", // pos-selected-bg (следва акцента на темата)
  brandTint2: "var(--color-pos-comment-brd)", // pos-comment-brd
  success: "var(--color-pos-served)", // pos-served
  danger: "var(--color-pos-danger-ink)", // pos-danger-ink
  mono: fontFamilies.mono,
  font: fontFamilies.sans,
} as const;
